import { Div } from "@tblabs/truffle";


export class Svg extends Div
{
    constructor(svg: string)
    {
        super();
        this.Html(svg).DisplayInlineBlock().Margin(8);
    }
}
